// ArabicKeyboardPopup.jsx
import { useRef } from "react";
import ArabicKeyboard from "./arabicKeyboard";
import "react-simple-keyboard/build/css/index.css";

export default function ArabicKeyboardPopup({
  value,
  setValue,
  onClose,
}) {
  const keyboardRef = useRef(null);

  return (
    <div className="keyboard-popup">
      <ArabicKeyboard
        onChange={(input) => setValue(input)}
      />

      <button className="btn btn-sm btn-secondary mt-2" onClick={onClose}>
        Close
      </button>
    </div>
  );
}
